<template>
  <div id="app">
    <Nav/>
    <Home/>
    <Game/>
    <!-- <Work/> -->
    <!-- <About/> -->
    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from './components/Nav'
import Home from './components/Home'
import Game from './components/Game'
import About from './components/About'
import Contact from './components/Contact'
import Footer from './components/Footer'

export default {
  name: 'App',
  components: {
    Nav,
    Home,
    Game,
    // About,
    Contact,
    Footer,
  }
}
</script>

<style>
.bg{
}
#app {
  /* height: 960px; */
  /* background: url("assets/bg.png") no-repeat;
  /* background-attachment: fixed; */
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  text-align: center;
  /* background-size: auto; */
  /* background-position: center center; */
  /* color: #2c3e50; */
  margin-top: 50px;
}


</style>



// WEBPACK FOOTER //
// src/App.vue